import angular from 'angular';
import DateService from './date.service';
import DebounceService from './debounce.service';
import MathFilter from './math.filter';
import RefresherDirective from './refresher.directive';
import StringService from './string.service';
import ButtonLink from './button-link.component';

/* @ngInject */
export default angular.module('autoboard.misc', [DateService, DebounceService, MathFilter, RefresherDirective, StringService, ButtonLink])
  .name;
